import Vue from 'vue'
import VueLodash from 'vue-lodash'
import App from './App.vue'
import axios from 'axios'
import router from './router'
import store from './stores/'
import Datetime from 'vue-datetime'
import VueMasonry from 'vue-masonry-css'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueGtag from 'vue-gtag'
import VueTelInput from 'vue-tel-input'
import 'vue-tel-input/dist/vue-tel-input.css'
import VueSignaturePad from 'vue-signature-pad'
import VueDaumPostcode from 'vue-daum-postcode'
import VCalendar from 'v-calendar'
import VueCookies from 'vue-cookies'

import '@/assets/css/common.scss'
import '@/assets/css/base.scss'
import '@/assets/css/style.scss'

/**
 * 브라우저에서 위치공유가 거부되어 있는 상황에서
 * 유저 region을 알 수 없을 때
 * 차선으로 해당 브라우저 언어의 언어-국가 정보를 얻어
 * 국가를 우선 선택
 * 이 값 또한 없을 경우 ip를 얻는 api를 호출하는데
 * 해당 api 호출 또한 거부되어 응답이 없음
 * 이 때는 직접 국가를 검색해야함
 */
const browserLangFirst = navigator.languages[0]
const browserLangs = navigator.languages.find(x => x.includes(browserLangFirst) && x.includes('-'))
const browserLang = browserLangs ? browserLangs.split('-')[1] : ''

Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.use(VueLodash)
Vue.use(Datetime)
Vue.use(VueMasonry)
Vue.use(VueTelInput, {
  defaultCountry: browserLang
})
Vue.use(VueSignaturePad)
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyD87kW7jzc3vPCMPA6SFTOglRHYvOb6D_o'
  }
})
Vue.use(VueGtag, {
  config: { id: 'UA-156911706-1' },
  includes: [{ id: 'UA-164342328-1' }]
})
Vue.use(VueDaumPostcode)
Vue.use(VCalendar, {
  componentPrefix: 'vc' // Use <vc-calendar /> instead of <v-calendar />
})
Vue.use(VueCookies)
// 태블릿으로 보낼 메시지 등록
// Vue.use(SendMessage)
// window.sendMessage = SendMessage

console.log('iSTAY viewer %c VER %c ' + process.env.VUE_APP_VERSION + ' ', 'background-color: #1e1e1e; color: #ffffff', 'background-color: #ea5404; color: #ffffff')


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
